import { render } from "./ListSections.vue?vue&type=template&id=6dfafab2&scoped=true"
import script from "./ListSections.vue?vue&type=script&lang=js"
export * from "./ListSections.vue?vue&type=script&lang=js"

import "./ListSections.vue?vue&type=style&index=0&id=6dfafab2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dfafab2"]])

export default __exports__